export const calcVideoDrawSize = (videoEl, isMobile = false) => {
  let sx = 0,
    sy = 0,
    sw = 720,
    sh = 1280;
  const vw = videoEl.videoWidth;
  const vh = videoEl.videoHeight;
  if (isMobile || vh > vw) {
    sw = vw;
    sx = 0;
    sh = vh;
  } else {
    let targetAspectRatio = 720 / 1280;
    sw = vh * targetAspectRatio;
    sh = vh;
    sx = vw / 2 - sw / 2;
  }
  return {
    sourceX: sx,
    sourceY: sy,
    sourceWidth: sw,
    sourceHeight: sh,
    videoWidth: vw,
    videoHeight: vh,
  };
};
